import React from 'react';
import { SocialLinksJumbotron, GameBadgesList } from 'Roblox';
import { withTranslations, WithTranslationsProps } from 'react-utilities';
import { aboutTabTranslationConfig } from '../translation.config';
import metadataConstants from '../constants/metadataConstants';
import { Description } from '../components/Description';

const { SocialLinkJumbotronType } = SocialLinksJumbotron;

export const AboutTab = ({ translate }: WithTranslationsProps): JSX.Element => {
  const { universeId = '', placeId = '' } = metadataConstants.metadataData() || {};
  return (
    <React.Fragment>
      <Description universeId={universeId} placeId={placeId} translate={translate} />
      <SocialLinksJumbotron type={SocialLinkJumbotronType.Game} targetId={universeId} />
      <GameBadgesList universeId={universeId} />
    </React.Fragment>
  );
};

export default withTranslations(AboutTab, aboutTabTranslationConfig);
